import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import lang from 'i18next';



const DataOnboarding = [
  {
    id: 'newclient',
    items: [
      { type: 'post', title: "New member", text: "Here you can add individual members and invite them to join your training space. Let's have a closer look...", element: '', image: '/img/onboarding/newclient1' },
      { type: 'pointer', title: "Enter your member's details", text: "Enter your member's basic details here. Only the Name field is mandatory.", element: '#ob-form', image: '' },
      { type: 'pointer', title: "Invite the member to join PT Mate", text: "We will send an email inviting them to join your training space via the Member App.\nSwitch this off if you don't want to invite them just yet.", element: '#ob-invite', image: '' },
      { type: 'pointer', title: "Additional options", text: "You can enter more details here, such as their date of birth and height.\n​​Note: The member will enter all of their information again when they connect via the Member App.", element: '#ob-more', image: '' },
      { type: 'pointer', title: "", text: "When you're ready create the member. They'll be added to your member list.", element: '#ob-button', image: '' },
      { type: 'pointer', title: "Your direct signup link", text: "Instead of adding members here, you can send them this link to your Member Area where they can create their account themselves and join your training space.", element: '#ob-link', image: '' },
      { type: 'post', title: "Next steps", text: "The member will receive an invite to create their Member account with PT Mate. Once registered, they will automatically join your training space.", element: '', image: '/img/onboarding/newclient2' },
      { type: 'post', title: "That's it. In a nutshell.", text: "Now it's time to add your first member. Feel free to create a test member first, such as yourself or a friend, to find out how it all works.Remember you can always reach out to us if you have any questions :)", element: '', image: '/img/onboarding/liftoff' },
    ]
  },
  {
    id: 'importclient',
    items: [
      { type: '', title: "", text: "", element: '', image: '' },
      { type: '', title: "", text: "", element: '', image: '' },
      { type: '', title: "", text: "", element: '', image: '' },
      { type: '', title: "", text: "", element: '', image: '' },
      { type: '', title: "", text: "", element: '', image: '' },
      { type: '', title: "", text: "", element: '', image: '' },
    ]
  },
]


class WidgetOnboarding extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      data: null,
      pos: 0,
      x: 0,
      y: 0,
      class: 'ob-element pointer small',
      class2: 'overlay onboarding',
      current: 0,
      show: props.show ?? false,
      hidden: '',
      margin: -180,
    };
  }
  

  componentWillReceiveProps(props) {
    this.setState({
      show: props.show,
      id: props.id,
    }, () => {
      if(this.state.show) {
        this.initialise()
      }
    })
  }


  initialise() {
    for(var item of DataOnboarding) {
      if(item.id === this.state.id) {
        this.setState({
          data: item
        })
      }
    }
    setTimeout(() => {
      if(this.state.data.items[this.state.current].type === 'post') {
        this.showPost()
      } else {
        this.showPointer(this.state.current)
      }
    }, 10);
  }


  hide() {
    this.setState({
      current: 0,
      x: 0,
      y: 0,
      class: 'ob-element pointer small',
      class2: 'overlay onboarding',
    })
    this.props.onHide(false)
  }


  showPost() {
    setTimeout(() => {
      //const height = this.divElement.clientHeight
      this.setState({
        hidden: '',
        //margin: -height/2,
        class: 'ob-element box auto',
        class2: 'overlay'
      });
    }, 500);
  }


  showPointer(next) {
    let elem = document.querySelector(this.state.data.items[next].element);
    let rect = elem.getBoundingClientRect();
    setTimeout(() => {
      this.setState({
        x: rect.x+rect.width+20,
        y: rect.y+window.pageYOffset
      })
    }, 300);
    setTimeout(() => {
      this.setState({
        class: 'ob-element pointer',
        class2: 'overlay onboarding'
      })
      elem.classList.add('ob-focus')
    }, 500);
  }


  clickNext() {
    if(this.state.data.items[this.state.current].type === 'pointer') {
      let elem1 = document.querySelector(this.state.data.items[this.state.current].element);
      elem1.classList.remove('ob-focus')
    }
    if(this.state.current < this.state.data.items.length-1) {
      var next = this.state.current+1
      this.setState({
        class: 'ob-element pointer small',
        current: next,
      })
      if(this.state.data.items[next].type === 'post') {
        this.showPost()
      } else {
        this.showPointer(next)
      }
    } else {

    }
  }


  renderStyles() {
    if(this.state.data.items[this.state.current].type === 'pointer') {
      return {top: this.state.y, left: this.state.x, zIndex: 99999}
    } else {
      return {marginTop: this.state.margin}
    }
  }


  renderPost() {
    if(this.state.data.items[this.state.current].type === 'post') {
      return (
        <div className="inner">
          <h2 className="lft mb-20">{this.state.data.items[this.state.current].title}</h2>
          <button className="btn tertiary small rgt close" onClick={() => this.hide()}>Close</button>
          <img src={this.state.data.items[this.state.current].image+'.jpg'} alt="Image" className="clear mb-20"/>
          <p className="clear mb-20">{this.state.data.items[this.state.current].text}</p>
          {this.renderButton()}
        </div>
      )
    }
  }


  renderButton() {
    if(this.state.current < this.state.data.items.length-1) {
      return <button className="btn tertiary" onClick={() => this.clickNext()}>Next</button>
    }
  }


  renderPointer() {
    if(this.state.data.items[this.state.current].type === 'pointer') {
      return (
        <div className="inner">
          <button className="btn tertiary small rgt close" style={{marginBottom:5}} onClick={() => this.hide()}>Close</button>
          <h4 className="mb-10 clear">{this.state.data.items[this.state.current].title}</h4>
          <p className="clear mb-10">{this.state.data.items[this.state.current].text}</p>
          {this.renderButton()}
        </div>
      )
    }
  }


  render() {
    if(this.state.show && this.state.data !== null) {
      if(this.state.data.items[this.state.current].type === 'post') {
        return (
          <div>
            <div className={this.state.class2+' '+this.state.hidden}>
              <div className={this.state.class} style={this.renderStyles()} ref={(divElement) => { this.divElement = divElement}}>
                {this.renderPost()}
                {this.renderPointer()}
              </div>
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <div className={this.state.class2+' '+this.state.hidden}></div>
            <div className={this.state.class} style={this.renderStyles()} ref={(divElement) => { this.divElement = divElement}}>
              {this.renderPost()}
              {this.renderPointer()}
            </div>
          </div>
        )
      }
    } else {
      return <div></div>
    }
  }
}


export default withTranslation(['widgets'])(WidgetOnboarding);